import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { Location, PaginatedLocationList } from "../../app/generated-axios-client";

export interface LocationState {
  location: Location | null;
  list: PaginatedLocationList;
}

const initialState: LocationState = {
  location: null,
  list: {
    pagination: {
      total_items: 0,
      total_pages: 0,
      current_page: 0,
      per_page: 0,
    },
    results: [],
  },
};

export const locationSlice = createSlice({
  name: "location",
  initialState,
  reducers: {
    addOrUpdateLocation: (state, action: PayloadAction<Location>) => {
      state.location = action.payload;
    },
    storeLocation: (state, action: PayloadAction<Location>) => {
      state.location = action.payload;
    },
    clearLocation: (state) => {
      state.location = null;
    },
    deleteLocation: (_state, _action: PayloadAction<string>) => {},
    addLocationList: (state, action: PayloadAction<PaginatedLocationList>) => {
      state.list = action.payload;
    },
  },
});

export const locationActions = locationSlice.actions;
export default locationSlice.reducer;
